import styled from "styled-components";

export const AudioPlayerWrap = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    width: 95%;
    margin: 0px;
  }
`;
